import {CatalogsState} from '../types/mx/reducers';
import {CatalogsHeadlessGraphCms, Offer, Wizard} from '../types/mx/catalog';

export const catalogInit: CatalogsState = {
    brands: [],
    models: [],
    versions: [],
    years: [],
    terms: [],
    employmentTypes: [],
    provinces: [],
    queryStringYear: 0,
    queryStringBrand:'',
    queryStringModel:'',
    queryStringVersion: '',
    queryStringProvince: '',
    queryStringIdVehicle: '',
    queryStringGroupName: '',
    queryStringGroupId: '',
    queryStringGroupLocation: '',
    queryStringOriginalPhoto: '',
    queryStringThumbnailPhoto: '',
    isUrlFromPI: false,
    bureauCatalogs: [],
    channelReferents: [],
    allQuotationInsurances: [],
    civilStatus: [],
    regime: [],
    rolHome: [],
    studies: [],
    houseType: [],
    lapse: [],
    employmentRotation: [],
    employmentBillingTypes: [],
    employmentTaxRegimes: [],
    headlessGraphCms: {
        offers: [] as Offer[],
        wizard: [] as Wizard[]
    } as CatalogsHeadlessGraphCms,
    catalogIsLoaded: false,
    crGender: [],
    crCivilStatus: [],
    crStudiesLevel: [],
    countriesWithNationalities: [],
    crHouseType: [],
    crDocumentType: [],
    crBusinessType: [],
};